import { Switch } from 'react-router-dom'
import { compose } from '@cbgms/base/utils/compose'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import List from './List'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_TELESALES } from 'app-support/permissions/Permissions'
import { telesalesRoute } from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler(telesalesRoute))

export const TelesalesContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_TELESALES} exact path={telesalesRoute} component={List} />
  </Switch>
)

export default enhance(TelesalesContainer)
